import Tooltip from '@liveauctioneers/caterwaul-components/lib/Tooltip/Tooltip';
import { Info } from '@liveauctioneers/hammer-ui-core/icons';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import React from 'react';

const WhatIsCountdownPopover = () => (
    <Tooltip
        placement="left"
        trigger={
            <Info
                color="primary"
                size="sm"
                style="fill"
            />
        }
    >
        <FormattedMessage id="itemBidding.dontWait" />
    </Tooltip>
);

export default WhatIsCountdownPopover;
